void import("./styles.css");

import { createRoot } from "react-dom/client";
import { AuthenticatedShopifyExtensionClientProvider } from "../../client/authenticated-client-context";
import { RedoShopifyRpcClientContextProvider } from "../../client/redo-shopify-rpc-client";
import { OrderTrackingLogin } from "../../order-tracking-login/order-tracking-login";
import STYLE_MANAGER from "../../style-manager";
import { waitForStoreUrl } from "../../utils/store-url";

const TARGET_ID = "redo-order-tracking-login-target";

async function initialize() {
  const target = document.getElementById(TARGET_ID);
  if (!target) {
    return;
  }

  const storeUrl = await waitForStoreUrl();
  if (!storeUrl) {
    // Rendering without a store URL throws while constructing the
    // authenticated client, leaving the block silently blank. Fail visibly
    // instead. Only console.error here: this is a standalone webpack entry,
    // so the storefront-log flush wiring (initStorefrontLogging) never runs
    // in it.
    console.error("Redo order tracking login: unable to resolve store URL");
    return;
  }

  const shadowHost = document.createElement("div");
  shadowHost.style.display = "unset";
  target.append(shadowHost);

  if (shadowHost.shadowRoot) {
    return;
  }

  const shadowRoot = shadowHost.attachShadow({ mode: "open" });
  STYLE_MANAGER.register(shadowRoot);

  const root = createRoot(shadowRoot);

  const shopifyServerUrl =
    globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    process.env.REDO_SHOPIFY_SERVER_URL!;

  root.render(
    <AuthenticatedShopifyExtensionClientProvider
      baseUrl={shopifyServerUrl}
      storeUrl={storeUrl}
    >
      <RedoShopifyRpcClientContextProvider
        baseUrl={shopifyServerUrl}
        storeUrl={storeUrl}
        widgetId={globalThis.redoWidgetId}
      >
        <OrderTrackingLogin
          returnAppUrl={
            globalThis.redoStorefront?.env?.REDO_RETURN_APP_URL ??
            process.env.REDO_RETURN_APP_URL
          }
        />
      </RedoShopifyRpcClientContextProvider>
    </AuthenticatedShopifyExtensionClientProvider>,
  );
}

void initialize();
